import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { NotificationCountService } from "src/app/services/notificationCountService";
import { SessionService } from "src/app/services/session.service";
import { environment } from "src/environments/environment";
import { LayoutService } from "src/app/services/layout.service";
import { ModalAuthService } from "src/app/services/ux/modal-auth.service";
import { LanguageService } from "src/app/services/language.service";

@Component({
  selector: "main-sidebar",
  templateUrl: "sidebar.component.html",
  styleUrls: ["./sidebar.component.css"]
})
export class SidebarComponent { 
  notificationCount: number;
  environment: any
  useSidebar: boolean = environment.useSidebar
  isBanking: boolean = environment.env === "banking"
  allowLanguageChange: boolean = environment.allowLanguageChange
  sidebarWidth: number;

  constructor(
    public session: SessionService,
    private router: Router,
    private notificationService: NotificationCountService,
    private layoutService: LayoutService,
    private AuthModalService: ModalAuthService,
    private languageService: LanguageService
  ) {
    this.environment = environment; 
    this.layoutService.sidebarWidth.subscribe(data => this.sidebarWidth = data)

    if (session.isLoggedIn()) {
      this.notificationService.getNotificationCount();
      // * subscribe to notification count service
      this.notificationService.count.subscribe(
        (count) => (this.notificationCount = count)
      );
    }
  }

  /**
   * @TODO: logout in backend
   */
  logout() {
    this.session.logout();
    this.router.navigate(["/"]);
  }

  login() {
    // open login modal
    this.AuthModalService.open();
  }

  navigate(path: string) {
    this.router.navigateByUrl(path)
  }

  changeLanguage(lang: string): void {
    this.languageService.setLanguage(lang);
  }
}
